// 会在前端项目中很早就执行的文件，适合放一些乱七八糟的预处理、清理等工作。
import Cookies from 'js-cookie';
import { KEY_MYGPT_COMPLETIONS } from '@mygpt/app/apis';
import { cookieConfig } from '@mygpt/app/apis/constant';

const allCookies = Cookies.get();
for (const key in allCookies) {
  // 清理掉以 KEY_MYGPT_COMPLETIONS 开头的 cookie。
  // 聊天记录数据不要存储到 cookie 里，因为很容易因为内容过长而导致遇到浏览器400错误
  if (key.startsWith(KEY_MYGPT_COMPLETIONS)) {
    Cookies.remove(key, { domain: cookieConfig.COOKIE_DOMAIN, path: '/' });
    console.log(`Remove ${KEY_MYGPT_COMPLETIONS} from cookie: ${key}`);
  }
}
